import { Logger } from '@ori/logger';

import { PACKAGE_NAME } from './constants';

export const mainLogger = new Logger(PACKAGE_NAME);
